<template>
  <BaseViewComponent
    name="rating"
    :is-preview="isPreview"
  >
    <div class="q-pb-lg q-px-lg rating-wrapper">
      <div class="rating-container flex column text-center">
        <div class="title-h2 q-py-xl text-center q-">
          {{ pageData.ratingTitle }}
        </div>
        <div class="text-p">
          {{ pageData.ratingDescription }}
        </div>

        <div>
          <BaseButton
            :label="pageData.ratingButtonText"
            class="q-my-lg"
          />
        </div>

        <div
          v-if="pageData.ratingRating"
          class="flex items-center justify-center q-mb-lg"
        >
          <q-icon
            v-for="star in 5"
            :key="star"
            name="fl:rating-star"
            size="30px"
            :class="star <= +pageData.ratingRating? 'text-primary-color' : 'text-grey'"
          />
        </div>
        <div class="note-p rating-note-container">
          {{ pageData.ratingNote }}
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import BaseButton from 'components/book-landing/render/BaseButton.vue';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);
</script>

<style lang="scss" scoped>
.rating-container {
  max-width: 600px;
  margin: 0 auto;

  @media screen and (max-width: $breakpoint-xs) {
    width: 100%;
  }
}

.rating-note-container {
  max-width: 400px;
  margin: 0 auto;
  @media screen and (max-width: $breakpoint-xs) {
    width: 100%;
  }
}
</style>
